import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker' 
import logout from './../../Global/logout' 

export default async function PutChangeStatus(
    row
) {
    const unHashedJwt = await checkJwt()
 
    if(!unHashedJwt){
        logout()
    }

    let data = {"devices": [
        {
          "deviceUuid": row.uuid,
          "enabled": !row.enabled
        }
      ]
    }

    return await resolve(
        axios( 'provider/client/device/changeStatus?clientUuid=' + row.clientUuid, {
            method: 'PUT',
            headers: { 'Authorization' : unHashedJwt.data},
            data: data
        }).then(
            res => (res)
        ).catch(error => error.response.data),
        "Admin"
    )
}